import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

import { DATE_TIME_PRECISE } from '@cast/constants';

export const getTimeAgo = (time: string, suffix?: boolean): string => {
  if (!time) {
    return '';
  }
  try {
    const date = dayjs(time);
    if (!date.isValid()) {
      return '';
    }
    return date.fromNow(!suffix);
  } catch (e) {
    console.error(e);
    return '';
  }
};

export const toDateTimePrecise = (time: string): string | undefined => {
  try {
    return dayjs(time).format(DATE_TIME_PRECISE);
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
